import React, { useEffect, useState } from 'react';
import VideoModal from './VideoModal';
import YtBtn from '../../assets/img/icon/YouTube_logo_03.png';
import dateSetting from '../../utils/dateSetting';
import { intervalLogging, stopLogging } from "../common/Logger";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

export default function PlayerSlideModal(props){
    const [cookies] = useCookies(['hiball_token']);
    const location = useLocation();

    const dateObj = dateSetting();
    const [modalState, setModalState] = useState(false);
    const [pID, setPID] = useState();

    let useLang = localStorage.getItem('language');

    useEffect(() => {
        if(props.checked){
            //만약 체크가 되어있다면(나와 상대한 것만 확인)
            setPID([props['profile']['playerId']]);
        } else {
            //체크가 되어있지 않다면(전체확인)
            setPID([]);
        }
    },[props.checked]);

    const openModal = () => {
        let locationSplit = location['pathname'].split('/');
        let playerType = locationSplit[1];
        let playerId = locationSplit[2];

        let vsPlayerType = props.position;
        let vsPlayerId = props.playerId;
        let playerObj = {
            playerType, playerId,
            vsPlayerType,
            vsPlayerId
        }

        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(true);
    }

    const closeModal = () => {
        let locationSplit = location['pathname'].split('/');
        let playerType = locationSplit[1];
        let playerId = locationSplit[2];

        let playerObj = {
            playerType,
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(false);
    }

    const playerNameEventHandler = (e) => {
        let playerInfo = e.currentTarget.id;
        
        let playerPosition = playerInfo.split("_")[0];
        let playerId = playerInfo.split("_")[1];

        window.location.href = '/'+playerPosition+"/"+playerId;
    }

    return (
        <>
            <img src={`http://image.hanwha.kbostat.net/profileImage/${props.playerId}.jpg`}
            id={`${props.playerId}_${props.position}`}
            alt="#" onError={props.onErrorHandler} onClick={openModal}/>
            <img className="ytBtn" src={YtBtn} alt="#"/>
            <p onClick={playerNameEventHandler} id={`${props.position}_${props.playerId}`}
            className='playerNameHover'
            style={useLang === "en" 
                    ? {textAlign:"center", marginTop:"5px", whiteSpace:"pre-line", cursor: 'pointer'}
                    : {textAlign:"center", marginTop:"5px", cursor: 'pointer'}}>
                {useLang === "en" ? props.playerEngName : props.playerName}
            </p>
            {props.position == 'pitcher' 
                ? <VideoModal content={"playerSlide"} modalState={modalState} closeModal={closeModal} 
                parameterSet={{"pitcherIds":[props.playerId], "playerIds":[props.playerId], "teamId":props.teamId, "position":props.position, "batterIds": pID, "seasons": [dateObj['season'], dateObj['season']-1]}} /> 
                : <VideoModal content={"playerSlide"} modalState={modalState} closeModal={closeModal} 
                parameterSet={{"batterIds":[props.playerId], "playerIds":[props.playerId], "teamId":props.teamId, "position":props.position, "pitcherIds": pID, "seasons": [dateObj['season'], dateObj['season']-1]}} /> 
            }
            
        </>
    )
}